import { useEffect } from "react"
import restRequest from "src/engine/modules/rest/api/request"
import { PLANS_URL, CALENDAR_URL } from "src/constants/routeNames"

export function usePlanByUuid(uuid, pushHistory, setError) {
  useEffect(() => {
    restRequest(PLANS_URL, { query: `uuid==${uuid}` })
      .then(result =>
        pushHistory(`${PLANS_URL}/${result.data[0].id}${CALENDAR_URL}`),
      )
      .catch(() => setError(true))
  }, [uuid])
}
